/**
 * 运营监控模块接口列表
 */

import base from './base'; // 导入接口域名列表
import axios from './axios';
import qs from 'qs';
//获取策略参数设置
export const getListMonitor = (params)=>{
  return axios.post(`${base.base}/monitor/get_list_monitor`,
    qs.stringify(params)
  )
};

export default getListMonitor;



// WEBPACK FOOTER //
// ./src/api/monitor.js